<template lang="pug">
.activities-location-sidebar-sites-tab
  AppToggleButtonGroup.mb-10(
    :items="jobSitesModeOptions"
    :selected="sitesViewMode"
    @input="onSelectSitesViewMode"
  )
  AppInputSearch
    AppInput(
      type="search"
      :debounce="150"
      placeholder="Search job sites"
      @input="$emit('input', $event)"
    )
  ActivitiesLocationSortBy(
    label="Sort by"
    :value="jobSitesGroupBy"
    :options="jobSitesGroupByOptions"
    @input="jobSitesGroupBy = $event"
  )
  .manage-job-sites
    a.d-flex.align-items-center.justify-content-center(:href="jobSitesUrl()")
      i.hi.hi-settings
      | Manage job sites
  template(v-if="!hasJobSites")
    template(v-if="sitesViewMode === 0")
      .text-lighter {{ noVisitedSitesText }}
    template(v-else)
      .text-lighter(v-if="query")
        | {{ noAllSitesText }}
      .text-lighter.text-center(v-else)
        img(
          :src="noSitesImageUrl"
          alt="No job sites created yet"
        )
        .mb-20.mt-10
          | {{ noAllSitesText }}
        AppButton(
          type="primary"
          block
          @click="navigateToJobSites"
        )
          | Add job site
</template>

<script>
import { isMobile } from '~/mixins';
import { mapActions, mapState } from 'vuex';
import { IMAGE_NO_SITES } from '~/rails_assets';
import { LOCATION_SITES_MODE_OPTIONS, LOCATION_SITES_MODE, LOCATION_VIEW } from '~/app_constants';

export default {
  name: 'ActivitiesLocationSidebarJobSitesTab',
  mixins: [isMobile],
  props: {
    hasJobSites: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    query: '',
    jobSiteLabel: 'job site',
    jobSitesGroupBy: { id: 'lastVisited', text: 'Last visited' },
    noSitesImageUrl: IMAGE_NO_SITES,
    jobSitesModeOptions: Object.freeze(LOCATION_SITES_MODE_OPTIONS),
    jobSitesGroupByOptions: Object.freeze([
      { id: 'lastVisited', text: 'Last visited' },
      { id: 'alpha', text: 'Alphabetically' },
    ]),
  }),
  computed: {
    ...mapState(['currentView', 'sitesViewMode']),
    noAllSitesText() {
      const pluralized = this.$options.filters.pluralize(2, this.jobSiteLabel);

      return this.query && this.query.length ? `No ${pluralized} matched this search` : `No ${pluralized} created yet`;
    },
    noVisitedSitesText() {
      const pluralized = this.$options.filters.pluralize(2, this.jobSiteLabel);

      return this.query && this.query.length
        ? `No ${pluralized} matched this search`
        : `No ${pluralized} have been visited for this day`;
    },
  },
  watch: {
    currentView(newValue) {
      const newTab = newValue === LOCATION_VIEW.LIVE ? LOCATION_SITES_MODE.ALL : LOCATION_SITES_MODE.VISITED;

      this.setSitesViewMode(newTab);
    },
    jobSitesGroupBy(newValue) {
      this.$emit('group-by-changed', newValue);
    },
  },
  methods: {
    ...mapActions(['selectSite', 'setSitesViewMode']),
    navigateToJobSites() {
      const url = this.jobSitesUrl('?showNewJobSiteWizard');

      window.location.href = url;
    },
    jobSitesUrl(param = '') {
      return `/organizations/${this.$store.state.organization.id}/job_sites${param}`;
    },
    onSelectSitesViewMode(mode) {
      /**
       * If we change site tabs/modes and we currently
       * have a site selected, check if it has been visited
       * if so, changing between tabs should not affect it,
       * and thus we don't need to clear the selected site
       * from the state.
       */
      if (this.selectedSite && !this.selectedSite.visited) {
        this.selectSite(null);
      }

      this.setSitesViewMode(mode);
    },
  },
};
</script>
